import { MessagesSquare } from 'lucide-react';
import { contato, nomeParceiro } from '../../nucleo/formato';
import { caminhoDaAba, type FonteBuscaGlobal } from '../../nucleo/modulos-web';

/**
 * Lista de 30/10 (item 10): conversas (contato e telefone, pela busca da caixa, que já respeita fila e caixa pessoal). Abre a
 * conversa na caixa do canal (`?conversa=`). Só dos canais com a página liberada (rl30-1 SEG-M2).
 */
interface ConversaBusca {
  id: string;
  canal: string;
  parceiro_nome: string | null;
  contato_externo: string;
}

export const buscaConversas: FonteBuscaGlobal[] = [
  {
    chave: 'conversas',
    permissao: 'conversas.ver',
    // Review rl30-1 (SEG-M2): uma página por canal; o servidor só devolve os canais liberados.
    paginas: ['conversas.whatsapp', 'conversas.instagram', 'conversas.email', 'conversas.portal', 'conversas.site'],
    grupo: 'buscaGlobal.conversas',
    posicao: 65,
    icone: MessagesSquare,
    item: (c: ConversaBusca, t) => ({
      id: c.id,
      rotulo: c.parceiro_nome ? nomeParceiro(c.parceiro_nome) : contato(c.contato_externo),
      detalhe: t(`abas.${c.canal}`),
      link: `${caminhoDaAba('conversas', c.canal) ?? caminhoDaAba('conversas', 'whatsapp')}?conversa=${c.id}`,
    }),
  },
];
